import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/**
 * Bootstrap idempotente del ruolo admin.
 * Se l'email dell'utente autenticato coincide (case-insensitive) con
 * process.env.ADMIN_EMAIL, assicura la presenza della riga (user_id, 'admin')
 * nella tabella user_roles. Nessun effetto per le altre email.
 */
export const ensureAdminBootstrap = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const adminEmail = (process.env.ADMIN_EMAIL ?? "").trim().toLowerCase();
    if (!adminEmail) return { isAdmin: false, bootstrapped: false };

    const userEmail = (context.claims?.email ?? "").trim().toLowerCase();
    if (!userEmail || userEmail !== adminEmail) {
      // Non è l'admin configurato: non fare nulla.
      const { data } = await context.supabase.rpc("has_role", {
        _user_id: context.userId,
        _role: "admin",
      });
      return { isAdmin: !!data, bootstrapped: false };
    }

    // È l'admin configurato: assicura il ruolo (idempotente).
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin
      .from("user_roles")
      .upsert(
        { user_id: context.userId, role: "admin" },
        { onConflict: "user_id,role", ignoreDuplicates: true },
      );
    if (error) throw error;

    return { isAdmin: true, bootstrapped: true };
  });